/**
 * @class
 * @memberOf P3.utils
 */
export default class TweenList {
    constructor() {
        this._tweens = [];
    }

    destroy() {
        this.killAll();

        this._tweens = null;
    }

    /**
     * @param {...TweenMax|TweenLite|TimelineMax|TimelineLite} tween - The tween(s) to add to the list.
     * @returns {TweenMax|TweenLite|TimelineMax|TimelineLite} The first tween that was added.
     */
    add(tween) {
        const len = arguments.length;
        if (len > 1) {
            for (let i = 0; i < len; ++i) {
                this.add(arguments[tween]);
            }
        } else {
            if (this._tweens.indexOf(tween) !== -1) return tween;
            this._tweens.push(tween);
        }
        return tween;
    }

    /**
     * @param {...TweenMax|TweenLite|TimelineMax|TimelineLite} tween - The tween(s) to remove from the list.
     * @returns {TweenMax|TweenLite|TimelineMax|TimelineLite} The first tween that was removed.
     */
    remove(tween) {
        const len = arguments.length;
        if (len > 1) {
            for (let i = len - 1; i >= 0; --i) {
                this.add(arguments[tween]);
            }
        } else {
            const i = this._tweens.indexOf(tween);
            if (i === -1) return;
            this._tweens.splice(i, 1);
        }
        return tween;
    }
    
    pauseAll() {
        for (let i = 0; i < this._tweens.length; ++i) {
            const tween = this._tweens[i];
            tween.pause();
        }
    }
    
    resumeAll() {
        for (let i = 0; i < this._tweens.length; ++i) {
            const tween = this._tweens[i];
            tween.resume();
        }
    }

    pauseAll() {
        for (let i = 0; i < this._tweens.length; ++i) {
            const tween = this._tweens[i];
            tween.pause();
        }
    }

    resumeAll() {
        for (let i = 0; i < this._tweens.length; ++i) {
            const tween = this._tweens[i];
            tween.resume();
        }
    }

    killAll() {
        for (let i = 0; i < this._tweens.length; ++i) {
            const tween = this._tweens[i];
            tween.kill();
        }
        this._tweens.length = 0;
    }
}